function constructQueryStringFromObject(query) {
  let queryString = ""
  Object?.keys(query).forEach((key) => {
    if (key !== "slug") {
      queryString =
        queryString +
        `${queryString.length === 0 ? "" : "&"}${key}=${encodeURIComponent(
          query[key]
        )}`
    }
  })
  return queryString
}

import React, { PureComponent } from "react"
import { Query, Mutation } from "react-apollo"
import gql from "graphql-tag"
import Link from "next/link"
import { LOCAL_TOGGLE_OVERLAY_MUTATION } from "../../apollo-state/graphql/mutations"

import "./pagination.scss"

const PAGINATION_QUERY = gql`
  query PAGINATION_QUERY($where: String) {
    usersLookingForCofounderConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`

class Pagination extends PureComponent {
  render() {
    const { usersPerPage, pageNumber, variables, me, query } = this.props
    const queryStringWithoutSlug = constructQueryStringFromObject(query)
    const paginationQueryString =
      queryStringWithoutSlug.length > 0 ? "?" + queryStringWithoutSlug : ""

    return (
      <div className="pagination">
        <Query query={PAGINATION_QUERY} variables={variables}>
          {({ data, loading, error }) => {
            if (loading) return <span />
            if (error) return <span />
            const { count } = data.usersLookingForCofounderConnection.aggregate
            const pages = Math.ceil(count / usersPerPage)
            return (
              <>
                {pageNumber === 2 && (
                  <Link
                    href={`/find-a-co-founder${paginationQueryString}`}
                    as={`/find-a-co-founder${paginationQueryString}`}
                  >
                    <a className="pagination__prev-next">← Prev</a>
                  </Link>
                )}
                {pageNumber > 2 && (
                  <Link
                    href={`/find-a-co-founder?slug=page-${
                      pageNumber - 1
                    }&${paginationQueryString.substring(1)}`}
                    as={`/find-a-co-founder/page-${
                      pageNumber - 1
                    }${paginationQueryString}`}
                  >
                    <a className="pagination__prev-next">← Prev</a>
                  </Link>
                )}
                {pageNumber < pages && (
                  <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                    {(signUp) => (
                      <>
                        {me ? (
                          <Link
                            href={`/find-a-co-founder?slug=page-${
                              pageNumber + 1
                            }&${paginationQueryString.substring(1)}`}
                            as={`/find-a-co-founder/page-${
                              pageNumber + 1
                            }${paginationQueryString}`}
                          >
                            <a className="pagination__prev-next">More →</a>
                          </Link>
                        ) : (
                          <button
                            onClick={signUp}
                            className="pagination__prev-next"
                          >
                            More →
                          </button>
                        )}
                      </>
                    )}
                  </Mutation>
                )}
                {me && pages > 0 && (
                  <div className="pagination__details">
                    page <strong>{pageNumber}</strong> of{" "}
                    <strong>{pages}</strong>
                  </div>
                )}
              </>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default Pagination
